import {urlAddDevice, urlDecommission, urlDeviceInfo, urlSensorInfo} from './apiUrls'

export async function addDevice (siteId, deviceId, ss) {
  const url = urlAddDevice(siteId, deviceId)
  return ss.apiInsertData(url, null)
}

export async function setDeviceInfo(siteId, deviceId, apiObj, ss) {
  const url = urlDeviceInfo (deviceId, siteId)
  return ss.apiSaveData(url, apiObj)
}
export async function setSensorInfo(siteId, deviceId, apiObj, ss) {
  let resp = []
  apiObj.forEach ((item, index) => {
    const url = urlSensorInfo(deviceId, siteId, index)
      resp.push(ss.apiSaveData (url, item, true))
  })
  return Promise.all(resp)
}
export async function setNewSensorInfo(siteId, deviceId, apiObj, ss) {
  let resp = []
    apiObj.forEach ((item, index) => {
      const url = urlSensorInfo(deviceId, siteId, index)
      resp.push(ss.apiSaveData (url, item))
  })
  return Promise.all(resp)
}
export async function decommission (deviceId, siteId, ss) {
  const url = urlDecommission(deviceId, siteId)
  return ss.apiDeleteData(url, null, true)
}
